import styled from '@emotion/styled/macro';

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  background: #ffffff;
`;

export const Title = styled.h1`
  font-family: 'FuturaStd';
  font-weight: 700;
  font-size: ${24 / 16}rem;
`;
